<template>
    <div class="tests-page-header">
        <div class="is-flex">
            <a
                v-if="returnButton && isShowNavigation"
                :href="returnButton.href"
                @click="returnButton.handler"
                class="has-text-link"
            >
                <span class="icon">
                    <i class="fas fa-chevron-left"></i>
                </span>
                <span>
                    {{ returnButton.text }}
                </span>
            </a>
            <h1
                v-if="title && !returnButton"
                :title="title"
                :class="{ 'is-one-line-title': isOneLineTitle }"
            >
                {{ title }}
            </h1>
            <div class="ml-auto is-flex is-align-items-center" v-if="isShowNavigation">
                <div class="fullscreen-icon" @click.stop="toggleFullscreen">
                    <svg v-if="isFullScreenTest">
                        <use xlink:href="#smallscreen-icon"></use>
                    </svg>
                    <svg v-else>
                        <use xlink:href="#fullscreen-icon"></use>
                    </svg>
                </div>
                <button class="delete" aria-label="close" @click="hideTestsManagementPage"></button>
            </div>
        </div>

        <h1
            v-if="returnButton && title"
            :title="title"
            class="test-new-line-title"
            :class="{ 'is-one-line-title': isOneLineTitle }"
        >
            {{ title }}
        </h1>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "TestPageHeader",
    props: {
        title: String,
        isOneLineTitle: false,
        returnButton: Object,
        isShowNavigation: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        ...mapActions('tests', [
            'hideTestsManagementPage',
            'toggleFullscreen',
        ]),
    },
    computed: {
        ...mapGetters('tests', [
            'isFullScreenTest',
        ]),
    }
}
</script>

<style lang="scss" scoped>
.test-new-line-title {
    margin-top: 10px;
}
.delete {
    align-self: center;
}

h1 {
    align-items: center;
    font-size: 28px;
    font-style: normal;
    font-weight: bold;

    &.is-one-line-title {
        margin-right: 10px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
}

.fullscreen-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
    margin-right: 10px;
    &:hover {
        svg use {
            fill: rgba(0, 0, 0, 0.3);
        }
    }
    svg {
        width: 100%;
        height: 100%;
        object-fit: cover;
        use {
            fill: rgba(0, 0, 0, 0.2);
        }
    }
}
</style>